import { logger } from '$lib/logger';
import type { HandleClientError } from '@sveltejs/kit';

const RELOAD_COOLDOWN_MS = 15000;

interface ErrorInfo {
    message: string;
    stack?: string;
}

export const handleError: HandleClientError = async ({ error, event, status, message }) => {
    const parsedError = extractErrorInfo(error, message);

    if (isChunkLoadError(parsedError.message) && attemptSafeReload()) {
        return;
    }

    const uri = event.route.id || event.url.pathname;
    const url = event.url.pathname;

    await logger.error(
        `[Client Status ${status}] ${parsedError.message}`,
        parsedError.stack,
        undefined,
        uri,
        url
    );
};

function extractErrorInfo(error: unknown, fallbackMessage: string): ErrorInfo {
    if (error instanceof Error) {
        return { message: error.message, stack: error.stack };
    }

    if (error && typeof error === 'object') {
        const raw = (error as any).error || error;
        return {
            message: String(raw.message || fallbackMessage),
            stack: raw.stack ? String(raw.stack) : undefined
        };
    }

    return { message: fallbackMessage };
}

function isChunkLoadError(message: string): boolean {
    const lower = message.toLowerCase();
    const fileNotFound = lower.includes('failed to fetch dynamically imported module') || lower.includes('importing a module script failed');
    return fileNotFound;
}

function attemptSafeReload(): boolean {
    const now = Date.now();
    const key = 'last-chunk-reload';
    const lastReload = sessionStorage.getItem(key);
    if (lastReload && now - parseInt(lastReload, 10) < RELOAD_COOLDOWN_MS) {
        return false;
    }
    console.log('Reloading page due to chunk load error');
    sessionStorage.setItem(key, String(now));
    window.location.reload();
    return true;
}